import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Mixins, Prop } from 'vue-property-decorator';
import Course from '@/content/models/course.model';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';
import { MULTIMEDIA_FILES_TYPES_EXT } from '@/courses/values/courses.values';
import { COURSE_EVENTS } from '@/content/values/events';


@Component({})
class EdPdfZoomControls extends Mixins(CourseToolsMixin) {

  @Prop() readonly courseId: number;

  get zoomObject(): boolean {
    return this.$store.state.CourseStore.zoomObject;
  }

  get pdfLoading(): boolean {
    return this.$store.state.CourseStore.pdfLoading;
  }

  get course(): Course {
    return this.getCourseFromStore({ courseId: this.courseId })
  }

  get isZoomDisabled () {
    let disabled = true;
    if(this.course) {
      disabled = this.course.viewer.materialSelected || this.course.viewer.sectionSelected || this.course.viewer.projectSelected ? false : true;
      if (this.course.viewer.sectionSelected && (this.course.viewer.sectionSelected.type == 'LESSON_SPLIT_TYPE' ||
        this.course.viewer.sectionSelected.type ==  'LESSON_SPLIT_WRITE')) {
          disabled = this.$store.state.CourseStore.isSplitHorizontal || this.$store.state.CourseStore.isSplitVertical
        }
      if (this.course.viewer.projectSelected?.section && (this.course.viewer.projectSelected.section.type == 'LESSON_SPLIT_TYPE' ||
        this.course.viewer.projectSelected.section.type ==  'LESSON_SPLIT_WRITE')) {
          disabled = this.$store.state.CourseStore.isSplitHorizontal || this.$store.state.CourseStore.isSplitVertical
        }
      if(this.$store.state.CourseStore.showSectionPersonCourseViewer) {
          disabled = true;
      }
    }
    return disabled;
  }

  get isPdf () {
    let pdf = false;
    if(this.course) {
      pdf = this.course.viewer.materialSelected || this.course.viewer.sectionSelected || this.course.viewer.projectSelected?.section ? true : false;
      let isDirectory =  this.course.viewer.sectionSelected?.assetsInfo?.reduce( (directory, asset ) => asset.directory && asset.pdfUrl != null, true);
      if(this.course.viewer.sectionSelected && (this.course.viewer.sectionSelected.type == 'LESSON_EXTERNAL_LINK' ||
        this.course.viewer.sectionSelected.type == 'SUBDECK' || 
        this.course.viewer.sectionSelected.type == 'LESSON_VIDEO' || 
        this.course.viewer.sectionSelected.type == 'LESSON_IMAGES' ||
        this.course.viewer.sectionSelected.type == 'LESSON_AUDIO_FILE' ||
        this.course.viewer.sectionSelected.type == 'LESSON_VIDEO_FILE' ||
        this.course.viewer.sectionSelected.type == 'LESSON_TEXT' || 
        this.course.viewer.sectionSelected.type == 'SECTION' || isDirectory ||
        this.course.viewer.sectionSelected.type == 'LESSON_PPT_HTML' ||
        this.isFileScannedAsImage)) {
          pdf = false
      }
      if(this.course.viewer.projectSelected?.section && (this.course.viewer.projectSelected.section.type == 'LESSON_EXTERNAL_LINK' ||
        this.course.viewer.projectSelected.section.type == 'LESSON_VIDEO' || 
        this.course.viewer.projectSelected.section.type == 'LESSON_IMAGES' ||
        this.course.viewer.projectSelected.section.type == 'LESSON_AUDIO_FILE' ||
        this.course.viewer.projectSelected.section.type == 'LESSON_VIDEO_FILE' ||
        this.course.viewer.projectSelected.section.type == 'LESSON_TEXT' || 
        this.course.viewer.projectSelected.section.type == 'SECTION' || isDirectory ||
        this.course.viewer.projectSelected.section.type == 'LESSON_PPT_HTML')) {
          pdf = false
      }
      if (!this.course.component.name || this.course.component.name == 'LESSON_CREATOR' ||
        this.course.component.name == 'LESSON_MATERIAL_CREATOR' || this.course.component.name == 'PROJECT_CREATOR'){
          pdf = false
        }
      if(this.course.viewer.materialSelected) {
        MULTIMEDIA_FILES_TYPES_EXT[this.course.viewer.materialSelected.data.mimeType]
        if(MULTIMEDIA_FILES_TYPES_EXT[this.course.viewer.materialSelected.data.mimeType]) pdf = false;
      }
    }
    return pdf;
  }

  get isFileScannedAsImage() {
    return this.course.viewer.sectionSelected?.type === 'LESSON_PDF_IMAGE' && this.course.viewer.sectionSelected?.assetsInfo[0].pdfUrl === undefined;
  }

  setZoomObject(value: boolean) {
    this.$edEventBus.$emit(COURSE_EVENTS.CHANGE_PDF_ZOOM, value);
    this.$Courses.Store.setZoomObject(value);
  }

  @Watch('course', { immediate: true, deep: true })
  resetZoomObject() {
    this.$Courses.Store.setZoomObject(true);
    this.$edEventBus.$emit(COURSE_EVENTS.CHANGE_PDF_ZOOM, true);
  }

  // Force reload of styles when class for diabled changes (Safari)
  @Watch('isZoomDisabled')
  async reloadStylesOnZoom() {
    if (document && document.styleSheets.length > 0){
      try {
        var ss = document.styleSheets[0];
        ss.addRule('.reloadStyle', 'position: relative');
        ss.removeRule(ss.rules.length - 1);
      } catch(err) {
        // Do nothing
      }
    }
  }

  @Watch('pdfLoading')
  async reloadStylesOnPdfLoading() {
    if (document && document.styleSheets.length > 0){
      try {
        var ss = document.styleSheets[0];
        ss.addRule('.reloadStyle', 'position: relative');
        ss.removeRule(ss.rules.length - 1);
      } catch(err) {
        // Do nothing
      }
    }
  }

  mounted() {
    if(!this.$edEventBus['_events'][COURSE_EVENTS.CHANGE_ZOOM_VALUE]){
      this.$edEventBus.$on(COURSE_EVENTS.CHANGE_ZOOM_VALUE, this.setZoomObject);
    }
  }

  beforeDestroy() {
    this.$edEventBus.$off(COURSE_EVENTS.CHANGE_ZOOM_VALUE, this.setZoomObject);
  }

}
export default Vue.component('ed-pdf-zoom-controls', EdPdfZoomControls);